module.exports = __webpack_public_path__ + "img/home-default-1.49c3625.png";